var _defs, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHolidays(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 682.67 682.67",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 512h512v-512h-512z"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "currentColor"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 0 682.67)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(467,15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-422c-16.569 0-30 13.431-30 30v290h482v-290c0-16.569-13.431-30-30-30z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 30
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(497,335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h-482v90c0 16.569 13.431 30 30 30h422c16.569 0 30-13.431 30-30z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 30
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(196,413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v84",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 30
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(436,413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v84",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 30
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(316,413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v84",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 30
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76,413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0v84",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 30
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(157.76 216.78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c3.16 16.084 17.334 28.216 34.343 28.216 19.33 0 35-15.67 35-35s-15.67-35-35-35",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 30
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(192.1 175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c19.33 0 35-15.671 35-35 0-19.33-15.67-35.001-35-35.001-17.673 0-32.287 13.1-34.662 30.119-0.223 1.596-0.338 3.225-0.338 4.882",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 30
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(354.9 143.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0c0-21.482-17.415-38.897-38.897-38.897-21.483 0-38.898 17.415-38.898 38.897v62.205c0 21.483 17.415 38.898 38.898 38.898 21.482 0 38.897-17.415 38.897-38.898z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 30
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolidays);
export default __webpack_public_path__ + "static/media/holidays.129e2e6accceb13fbc9233c77c3e51a9.svg";
export { ForwardRef as ReactComponent };